import { withInstall, withNoopInstall } from '@zoryn/utils'
import Carousel from './src/carousel.vue'
import CarouselItem from './src/carousel-item.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZCarousel: SFCWithInstall<typeof Carousel> & {
  CarouselItem: typeof CarouselItem
} = withInstall(Carousel, {
  CarouselItem,
})

export default ZCarousel

export const ZCarouselItem: SFCWithInstall<typeof CarouselItem> =
  withNoopInstall(CarouselItem)

export * from './src/carousel'
export * from './src/carousel-item'
export * from './src/constants'

export type { CarouselInstance, CarouselItemInstance } from './src/instance'
